import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function Elevate() {
  const { t } = useTranslation("");
  return (
    <div>
      {/* Start  Page hero*/}
      <section className="page-hero  d-flex align-items-center" id="page-hero">
        <div
          className="overlay-photo-image-bg"
          data-bg-img="./assets/assets/images/sections-bg-images/pattern-bg-2.jpg"
          data-bg-opacity=".2"
        />
        <div className="particles-js  bubels" id="particles-js" />
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-12   mx-md-auto col-lg-6 text-center "
              data-tilt>
              <div className="hero-image-area mb-5 mb-lg-0">
                <div className="hero-img-wraper  ">
                  <img
                    className="img-fluid "
                    src="./assets/assets/images/hero/illustration-4.png"
                    alt
                    draggable="false"
                  />
                </div>
              </div>
            </div>
            {/*End of .image-area */}
            <div className="col-12 col-lg-6 ">
              {/*Start of .hero-text-area*/}
              <div className="hero-text-area   ">
                <div className="row">
                  <div className="col-12   ">
                    <div className="hero-social-icons mb-3 ">
                      <div className="sc-wrapper dir-row sc-flat"></div>
                    </div>
                  </div>
                  <div className="col-12       ">
                    <div className="pre-title ">
                      {t("elevate_by_im.heading")}{" "}
                    </div>
                    <h1 className="hero-title  ">
                      {t("elevate_by_im.heading")}{" "}
                      <span className="featured-text">
                        {t("elevate_by_im.blue")}{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="wavey-underline"
                          width="1104.664"
                          height="100.188"
                          viewBox="0 0 1104.664 100.188">
                          <path
                            id="Path_208"
                            data-name="Path 208"
                            d="M1395.385,1568.169a21.357,21.357,0,0,0-7.563,1.667c-5.893,2.122-10,6.516-13.9,10.646-9.685,10.253-18.565,21-27.757,31.568a74.7,74.7,0,0,1-10.36,9.6,40.274,40.274,0,0,1-4.749,2.291c-.58.154-1.151.288-1.731.406l-.07-.018c-.25-.121-.495-.247-.737-.381a69.246,69.246,0,0,1-9.219-8.363c-3.508-3.913-6.856-7.927-10.125-11.993a84.778,84.778,0,0,0-9.754-10.9,33.9,33.9,0,0,0-4.734-3.159,29.755,29.755,0,0,0-3.86-1.468,8.287,8.287,0,0,0-2.416-.514,25.223,25.223,0,0,0-8.575.116,37.238,37.238,0,0,0-6.61,2.031,55.378,55.378,0,0,0-9.6,5.049c-3.359,2.173-6.689,4.371-9.92,6.667-4.873,3.468-9.73,6.936-14.7,10.3a75.464,75.464,0,0,1-10.418,5.482c-.9.256-1.8.477-2.723.657h-.017q-.244-.123-.486-.252a123.025,123.025,0,0,1-14.522-13.025c-2.21-2.214-4.43-4.419-6.738-6.559a56.755,56.755,0,0,0-6.2-5.1,26.416,26.416,0,0,0-8.359-4.113,24.5,24.5,0,0,0-7.131-.829,24.16,24.16,0,0,0-5.9.953,45.529,45.529,0,0,0-4.43,1.659,25.049,25.049,0,0,0-3.88,2.388,43.866,43.866,0,0,0-7.121,6.052c-2.916,2.919-5.559,6.053-8.162,9.179-4.706,5.669-8.674,11.735-13.477,17.349a40.793,40.793,0,0,1-3.312,3.018c-1.77-.869-3.456-1.838-5.139-2.847-2.985-2.082-5.832-4.252-8.629-6.526-3.388-2.745-6.551-5.7-9.714-8.631q-4.449-4.13-8.909-8.259c-1.375-1.268-2.779-2.529-4.242-3.723-3.7-3.034-7.554-6.052-12.161-8.075-1.444-.531-2.887-1.037-4.341-1.534-.4-.091-.805-.191-1.208-.29q-2.3-.312-4.607-.539a24.017,24.017,0,0,0-7.9,1.153,22.473,22.473,0,0,0-4.194,1.633,32.6,32.6,0,0,0-4.823,3.142,25.689,25.689,0,0,0-3.968,3.7,143.436,143.436,0,0,0-9.822,11.674c-2.524,3.4-4.961,6.84-7.4,10.281-2.548,3.581-5.078,7.193-7.894,10.631l-.04-.024c-7.131-4.818-13.964-9.976-20.737-15.134-7.936-6.035-15.519-12.5-24.183-17.809a56.468,56.468,0,0,0-7.219-3.764,57.227,57.227,0,0,0-6.3-2.181,33.858,33.858,0,0,0-6.424-.846c-1.561.083-3.1.241-4.645.465a27.682,27.682,0,0,0-5.648,1.749,56.414,56.414,0,0,0-9.066,5.332,85.607,85.607,0,0,0-10.647,8.746c-7.2,6.686-13.456,14.117-19.865,21.341-1.1,1.186-2.207,2.358-3.38,3.482-.861-.86-1.69-1.744-2.512-2.624-5.094-5.73-9.878-11.655-15.025-17.348-1.866-2.065-3.753-4.105-5.688-6.111a54.566,54.566,0,0,0-4.606-4.17,26.641,26.641,0,0,0-7.464-4.362,19.329,19.329,0,0,0-3.969-1.268,23.247,23.247,0,0,0-5.412-.448,27.049,27.049,0,0,0-9.252,2.189,64.6,64.6,0,0,0-6.807,3.1,188.563,188.563,0,0,0-24.212,15.654c-7.265,5.4-14.36,11-21.938,16.1a58.665,58.665,0,0,1-8.325,4.456c-.832.234-1.648.426-2.5.589-.122,0-.244,0-.367,0l-.144-.033c-.107-.051-.212-.1-.317-.156a41.819,41.819,0,0,1-3.947-3.516,93.708,93.708,0,0,1-5.968-8.2c-1.867-2.852-3.585-5.779-5.432-8.639-3.28-5.091-6.748-10.223-11.767-14.261a20.525,20.525,0,0,0-7.534-3.789,16.866,16.866,0,0,0-4.292-.655,33.2,33.2,0,0,0-5.363.456c-1.316.381-2.612.821-3.87,1.318a27.008,27.008,0,0,0-3.428,1.816c-1.561.954-3.045,2-4.547,3.018a171.305,171.305,0,0,0-17.327,13.979c-5.795,5.153-11.268,10.63-17.718,15.214a48.483,48.483,0,0,1-4.709,2.516c-.392.114-.784.217-1.182.313-5.283-3.993-9.674-8.814-14.118-13.45-4.312-4.477-8.594-9-13.29-13.2-5.284-4.718-11.05-9.369-18.318-11.765a28.559,28.559,0,0,0-7.475-1.194c-1.424.124-2.838.306-4.233.539-1.307.414-2.6.862-3.879,1.343a33.49,33.49,0,0,0-5.452,3.607,42.418,42.418,0,0,0-4.754,4.833c-3.808,4.195-7.459,8.482-11.241,12.69-2.722,2.866-5.442,5.741-8.334,8.495a110.3,110.3,0,0,1-12.253,10.513c-.676.4-1.355.765-2.053,1.107-3.421-2.787-6.435-5.972-9.5-9.025s-6.12-6.1-9.273-9.071c-4.98-4.685-10.205-9.336-16.334-12.951a29.591,29.591,0,0,0-7.347-3.325,14.36,14.36,0,0,0-4.086-.688c-.491-.05-.992-.091-1.493-.141a36.093,36.093,0,0,0-3.782.489c-1.158.39-2.3.8-3.417,1.26a11.837,11.837,0,0,0-3.684,2.786,38.113,38.113,0,0,0-4.145,5.257,156.759,156.759,0,0,0-12.012,22.046c-1.651,3.549-3.016,7.172-4.371,10.8-.639,1.733-1.16,3.5-1.876,5.207-1.062,2.545-2.1,5.082-3.271,7.595a1.894,1.894,0,0,0,1.1,2.28,2.668,2.668,0,0,0,3.261-.73c2.73-3.971,5.716-7.736,8.859-11.475,2.878-3.424,5.933-6.749,8.919-10.107,5.268-5.9,10.466-11.851,15.731-17.75.333.183.663.37.993.562,7.6,5.265,13.967,11.673,20.286,17.984,2.485,2.479,4.94,4.983,7.484,7.421,2.515,2.413,5.019,4.933,8.261,6.707a18.993,18.993,0,0,0,6.217,2.173,21.641,21.641,0,0,0,10.373-.9c7.366-2.421,12.926-7.346,18.426-11.964,3.006-2.529,5.727-5.365,8.5-8.093,5.2-5.118,10.08-10.457,14.958-15.8,1.527-1.616,3.039-3.23,4.73-4.709.706.36,1.393.741,2.075,1.144,7.925,5.608,14.364,12.627,20.846,19.375,3.2,3.325,6.424,6.625,9.822,9.808a45.086,45.086,0,0,0,7.966,6.128,11.269,11.269,0,0,0,2.259,1.135c.874.316,1.748.622,2.623.937a12.809,12.809,0,0,0,4.155.68,26.906,26.906,0,0,0,11.226-1.4c7.927-2.57,14.409-7.429,20.283-12.47,3.094-2.653,6.07-5.414,9.125-8.093a234.791,234.791,0,0,1,18.358-14.822c4.517,5.537,7.877,11.693,11.747,17.551a73.925,73.925,0,0,0,7.5,9.568,51.738,51.738,0,0,0,4.686,4.46,29.5,29.5,0,0,0,3.427,2.363,24.359,24.359,0,0,0,5.3,2.421c5.706,2.032,12.306,1.617,18.023-.165,8.035-2.5,14.615-7.147,21.118-11.707,3.084-2.164,6.079-4.42,9.075-6.667,5.769-4.312,11.51-8.631,17.485-12.724a113.949,113.949,0,0,1,16.474-8.936,64.641,64.641,0,0,1,8.45,7.941c4.85,5.48,9.537,11.053,14.432,16.5a87.007,87.007,0,0,0,9.341,9.427,26.069,26.069,0,0,0,3.055,2.073,10.084,10.084,0,0,0,3.536,1.467,13.307,13.307,0,0,0,4.862.913,29.729,29.729,0,0,0,5.353-.639c3.418-.746,6.267-2.795,8.919-4.618a39.946,39.946,0,0,0,5.019-4.428c5.363-5.2,10.038-10.894,15.274-16.185a121.467,121.467,0,0,1,16.741-14.571c.87-.521,1.749-1.014,2.662-1.475l.276.073a51.763,51.763,0,0,1,6.551,3.257c6.848,4.661,13.244,9.761,19.747,14.756,7.259,5.572,14.665,11.069,22.317,16.243a57.253,57.253,0,0,0,8.819,5.281,20.68,20.68,0,0,0,9.312,1.883,19.363,19.363,0,0,0,7.406-1.7,42.414,42.414,0,0,0,5.382-3.3,20.763,20.763,0,0,0,2.161-1.924c1.454-1.393,2.741-2.926,4.077-4.394,1.325-1.451,2.485-3.01,3.673-4.544,1.463-1.881,2.878-3.78,4.293-5.687,4.834-6.49,9.512-13.021,14.91-19.18.555-.552,1.122-1.089,1.708-1.61.1.057.209.115.313.173,6.282,4.5,11.65,9.908,17.2,15.02a163.615,163.615,0,0,0,18.485,15.231c2.269,1.55,4.6,3.027,6.945,4.486a47.181,47.181,0,0,0,6.3,3.283,27.077,27.077,0,0,0,11.138,2.255,24.392,24.392,0,0,0,9.577-2.23,41.8,41.8,0,0,0,7.868-4.934,53.288,53.288,0,0,0,7.15-7.2c1.327-1.509,2.614-3.052,3.841-4.618,4.5-5.763,8.879-11.569,13.724-17.12,1.206-1.237,2.419-2.456,3.718-3.613,2.214,1.819,4.255,3.788,6.308,5.75,2.367,2.255,4.656,4.56,7,6.824,2.219,2.139,4.468,4.286,6.884,6.277.757.621,1.523,1.243,2.279,1.865a55.074,55.074,0,0,0,6.394,4.32,20.453,20.453,0,0,0,4.43,1.774,14.3,14.3,0,0,0,3.242.912c4.007.87,8.064.415,12.061-.158a34.471,34.471,0,0,0,7.5-2.321,63.157,63.157,0,0,0,6.434-2.977,109.528,109.528,0,0,0,10.53-6.592c2.848-1.948,5.687-3.913,8.437-5.952,5.157-3.823,10.248-7.693,15.573-11.348,1.425-.856,2.851-1.677,4.356-2.4a46.694,46.694,0,0,1,3.826,3.609c5.82,6.463,11.621,12.927,17.91,19.072a76.822,76.822,0,0,0,7.387,6.351,26.97,26.97,0,0,0,8.683,4.552,25.388,25.388,0,0,0,11.629.556,46.95,46.95,0,0,0,8.094-2.454,37.83,37.83,0,0,0,8.408-4.561,81.5,81.5,0,0,0,8.349-6.807c3.378-3.018,6.335-6.434,9.36-9.7,2.8-3.017,5.569-6.052,8.369-9.07,3.034-3.266,6.07-6.534,9.164-9.759,1.748-1.807,3.5-3.615,5.264-5.406,1.345-1.375,2.7-2.738,4.142-4.033,1.959,2.939,3.523,6.068,5.287,9.091a102.254,102.254,0,0,0,7.357,11.152,73.1,73.1,0,0,0,9.45,9.916,54.363,54.363,0,0,0,4.38,3.4,37.472,37.472,0,0,0,6.885,4,27.526,27.526,0,0,0,6.9,1.948,28.637,28.637,0,0,0,4.765.4,38.314,38.314,0,0,0,6.521-.713,34.284,34.284,0,0,0,7.22-2.255,55.5,55.5,0,0,0,7.534-3.673c8.564-4.892,15.921-11.276,23.14-17.478,2.564-2.2,5.1-4.427,7.642-6.642,2.695-2.334,5.41-4.692,8.34-6.825.169.152.337.308.5.465,2.514,3,4.676,6.19,7,9.3,2.23,2.993,4.509,5.961,6.807,8.921,2.092,2.7,4.243,5.423,6.561,8a54.978,54.978,0,0,0,7.072,7.13,18.737,18.737,0,0,0,6.876,3.467,26.353,26.353,0,0,0,10.47.3,71.973,71.973,0,0,0,15.814-5.315c2.74-1.193,5.363-2.537,8.015-3.863,3.841-1.924,7.524-4.022,11.236-6.111,1.474-.829,2.859-1.774,4.273-2.661,2.22-1.394,4.538-2.737,6.66-4.246,1.7-1.2,3.388-2.421,5.077-3.631,2.614-1.874,4.922-3.972,7.368-6a5.547,5.547,0,0,0,1.149-7.545,7.359,7.359,0,0,0-4.411-2.869,9.332,9.332,0,0,0-5.687.63c-.386.141-.768.284-1.152.427-2.566.891-5.157,1.755-7.609,2.84-2.092.928-4.194,1.857-6.286,2.786-3.252,1.442-6.345,3.159-9.488,4.742-8.387,4.231-16.5,8.768-25.376,12.235-1.145.358-2.293.671-3.47.941q-.555-.505-1.08-1.033a179.832,179.832,0,0,1-11.553-16.28c-2.043-3.109-4.107-6.193-6.228-9.261a49.911,49.911,0,0,0-3.281-4.17c-.933-1.054-1.9-2.09-2.9-3.1a24.214,24.214,0,0,0-20.44-6.153c-7.593,1.269-13.319,6.128-18.564,10.613-2.878,2.463-5.648,5-8.447,7.529a194.132,194.132,0,0,1-19.2,15.756,54.882,54.882,0,0,1-7.621,3.938c-.888.246-1.764.449-2.673.624-.143,0-.286.006-.43.006-.308-.063-.612-.133-.916-.209-.712-.338-1.4-.7-2.069-1.094a58.392,58.392,0,0,1-7.122-6.2,70.261,70.261,0,0,1-7.978-11.366c-1.778-3.168-3.477-6.368-5.225-9.552a26.78,26.78,0,0,0-9.774-10.63,21.285,21.285,0,0,0-6.944-2.544,22.865,22.865,0,0,0-4.153-.379c-.164,0-.328,0-.493.005Zm-2.8,18.564a9.723,9.723,0,0,1,1.384.495q-.693-.246-1.384-.495Zm7.023.141q-.51.184-1.025.367.5-.2,1.025-.367Zm100.709,4.264-.2.022.2-.022Zm1.365.167.107.038-.107-.037Zm-.949.133,0,0-.126.044.124-.046Zm-216.174,15.218,0,0c-.139.017-.278.032-.416.047.137-.019.274-.036.411-.05Zm1.107.139c.114.04.227.082.338.127l-.348-.123.01,0Zm-.411.191q.348.219.68.459l-.691-.453.011-.006Zm-105.625,1.694q.443.139.868.31l-.868-.31Zm-100.207.6-.692.077c.228-.033.46-.059.692-.077Zm-1.295.444c.1.014.19.028.284.045l-.3-.033.014-.012Zm364.3.261c-.211.029-.422.053-.633.074l0,0,.629-.072Zm-.653.075h0l-.019,0,.021,0Zm-476.071,1-.841.1c.28-.046.56-.078.841-.1Zm1.352.005c.283.022.566.055.851.1l-.857-.1.006,0Zm-.67.1-1.043.37q.512-.21,1.043-.37Zm575.443.37.324.213-.011,0c-.106-.07-.211-.142-.313-.216Zm1.708.191c-.3.046-.6.08-.9.1h0l.9-.1Zm-673.33,2.85c.182.016.366.035.548.06q-.274-.029-.548-.06Zm-.8.117q.425.134.837.3c-.282-.1-.563-.2-.845-.3l.008,0Zm-222.3.606-.54.062c.179-.026.358-.047.54-.062Zm-2.374.542.014.007-.252.09c.078-.034.159-.066.238-.1Zm.988.215c.066.023.132.048.2.073l-.2-.071v0Zm105.433.264c.17.054.336.113.5.175l-.5-.175Zm6.246.662-.6.068h0q.294-.045.6-.067Zm466.3.208,1.233.438c-.419-.126-.83-.273-1.233-.438Zm-.147.514.648.075c-.216-.021-.432-.045-.648-.075Zm-581.111,1.426c-.421.467-.847.929-1.269,1.39l1.269-1.39Zm684.823,5.083c.547.06,1.1.12,1.641.182a10.366,10.366,0,0,1-1.641-.182Zm-409.006,2.022c-.58.631-1.156,1.264-1.737,1.894.578-.629,1.158-1.265,1.737-1.894Zm220.5,3.282.669.076c-.225-.019-.448-.045-.669-.076Zm-345.858,6.8c.269.18.541.358.812.537-.278-.169-.549-.347-.812-.537Zm-.03.506,1.242.439a12.42,12.42,0,0,1-1.242-.439Zm-97.6.092.5.056c-.167-.016-.334-.034-.5-.056Zm97.8.423c.287.03.574.063.861.1-.288-.024-.574-.055-.861-.1Zm-201.748,2.76.552.36-.016.008c-.182-.118-.361-.24-.536-.368Zm-1.5.564,1.3.145-.017.007-.01,0a9.2,9.2,0,0,1-1.275-.154Zm2.877.092c-.062.008-.125.014-.187.021h0l.189-.02Z"
                            transform="translate(-504.796 -1565.664)"
                            fill="none"
                            stroke="#030303"
                            strokeWidth={5}
                          />
                        </svg>
                      </span>
                      <span className="design-element rounded-shape stripes" />
                    </h1>
                  </div>
                  <div className="col-10">
                    <p className="hero-subtitle">{t("elevate_by_im.para")}</p>
                  </div>
                  <div className="col-12   "></div>
                </div>
              </div>
              {/*End of .hero-text-area*/}
            </div>
          </div>
        </div>
      </section>
      {/* End  Page hero*/}
      {/* Start  services Section*/}
      <section className="services services-boxed mega-section  " id="services">
        <div className="container">
          <div className="sec-heading  ">
            <div className="content-area">
              <span className=" pre-title wow fadeInUp " data-wow-delay=".2s">
                {t("elevate_by_im.program.p1.title")}
              </span>
              <h2 className=" title    wow fadeInUp" data-wow-delay=".4s">
                <span className="hollow-text">
                  {t("elevate_by_im.program.p1.title")}{" "}
                </span>{" "}
                Phases
              </h2>
            </div>
          </div>
          <div className="row gx-4 gy-4 services-row ">
            <div className="col-12 col-md-3  col-lg-3 mx-auto ">
              {/*Start First service box*/}
              <div
                className="box service-box  wow fadeInUp reveal-start"
                data-wow-offset={0}
                data-wow-delay=".1s">
                <div className="service-icon">
                  <i className="flaticon-web-development font-icon" />
                </div>
                <span className="service-num hollow-text">1 </span>
                <div className="service-content">
                  <h3 className="service-title">
                    {" "}
                    {t("elevate_by_im.program.p1.title")}
                  </h3>
                  <p className="service-text">
                    {t("elevate_by_im.program.p1.para")}
                  </p>
                </div>
                <Link className="read-more" to="/Alpha">
                  {t("elevate_by_im.program.p1.button")}
                  <i className="bi bi-arrow-right icon " />
                </Link>
              </div>
              {/* End First service box   */}
            </div>
            <div className="col-12 col-md-3  col-lg-3 mx-auto ">
              {/*Start First service box*/}
              <div
                className="box service-box  wow fadeInUp reveal-start"
                data-wow-offset={0}
                data-wow-delay=".1s">
                <div className="service-icon">
                  <i className="flaticon-web-development font-icon" />
                </div>
                <span className="service-num hollow-text">1 </span>
                <div className="service-content">
                  <h3 className="service-title">
                    {t("elevate_by_im.program.p2.title")}
                  </h3>
                  <p className="service-text">
                    {t("elevate_by_im.program.p2.para")}
                  </p>
                </div>
                <Link className="read-more" to="/Beta">
                  {t("elevate_by_im.program.p2.button")}
                  <i className="bi bi-arrow-right icon " />
                </Link>
              </div>
              {/* End First service box   */}
            </div>
            <div className="col-12 col-md-3  col-lg-3 mx-auto ">
              <div
                className="box service-box  wow fadeInUp reveal-start"
                data-wow-offset={0}
                data-wow-delay=".1s">
                <div className="service-icon">
                  <i className="flaticon-web-development font-icon" />
                </div>
                <span className="service-num hollow-text">1 </span>
                <div className="service-content">
                  <h3 className="service-title">
                    {t("elevate_by_im.program.p3.title")}
                  </h3>
                  <p className="service-text">
                    {t("elevate_by_im.program.p3.para")}
                  </p>
                </div>
                <Link className="read-more" to="/Gamma">
                  {t("elevate_by_im.program.p3.button")}
                  <i className="bi bi-arrow-right icon " />
                </Link>
              </div>
            </div>
            <div className="col-12 col-md-3  col-lg-3 mx-auto ">
              <div
                className="box service-box  wow fadeInUp reveal-start"
                data-wow-offset={0}
                data-wow-delay=".1s">
                <div className="service-icon">
                  <i className="flaticon-web-development font-icon" />
                </div>
                <span className="service-num hollow-text">1 </span>
                <div className="service-content">
                  <h3 className="service-title">
                    {t("elevate_by_im.program.p4.title")}
                  </h3>
                  <p className="service-text">
                    {t("elevate_by_im.program.p4.para")}
                  </p>
                </div>
                <Link className="read-more" to="/Sigma">
                  {t("elevate_by_im.program.p4.button")}
                  <i className="bi bi-arrow-right icon " />
                </Link>
              </div>
              {/* End First service box   */}
            </div>
          </div>
        </div>
      </section>
      {/* End  services Section*/}
      {/* Start  about Section*/}
      <section className="about mega-section" id="about">
        <div className="container">
          {/* Start first about div*/}

          <div className="content-block  ">
            <div className="row">
              <div
                className="col-12 col-lg-6 d-flex align-items-center about-col  wow fadeInUp"
                data-wow-delay="0.2s">
                <div className="img-area  ">
                  <div className="image  " data-tilt>
                    <img
                      className="about-img img-fluid "
                      loading="lazy"
                      src="./assets/assets/images/about/2.png"
                      alt="about"
                    />
                  </div>
                </div>
              </div>
              <div
                className="col-12 col-lg-6 d-flex align-items-center about-col pad-start  wow fadeInUp "
                data-wow-delay="0.6s">
                <div className="text-area ">
                  <div className="sec-heading  light-title ">
                    <div className="content-area">
                      <span
                        className=" pre-title       wow fadeInUp "
                        data-wow-delay=".2s">
                        Distinguished Features
                      </span>
                      <h2
                        className=" title    wow fadeInUp"
                        data-wow-delay=".4s">
                        Key Offerings of UIM
                        <span className="hollow-text">Features</span>
                      </h2>
                    </div>
                  </div>

                  <div className="info-items-list">
                    <div className="row ">
                      <div className="col-12 ">
                        <div className="info-item">
                          <span className="info-number ">01.</span>
                          <div className="info-content">
                            <h5 className="info-title">
                              3D Immersive Virtual Environment
                            </h5>
                            <p className="info-text">
                              • UIM’s immersive platform creates a comprehensive
                              and resourceful ecosystem for startups, simulating
                              real-world environments for collaboration,
                              networking, and mentorship.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 ">
                        <div className="info-item">
                          <span className="info-number ">02.</span>
                          <div className="info-content">
                            <h5 className="info-title">
                              AI Empowered Financial Modelling
                            </h5>
                            <p className="info-text">
                              • Our AI-driven system helps startups generate
                              tailored business and revenue models. This
                              predictive tool ensures that each startup is
                              equipped with a financially viable strategy,
                              optimized for profitability & scalability.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 ">
                        <div className="info-item">
                          <span className="info-number ">03.</span>
                          <div className="info-content">
                            <h5 className="info-title">
                              Tailored Mentorship Matching{" "}
                            </h5>
                            <p className="info-text">
                              • We connect startups with dedicated mentors whose
                              expertise aligns with their specific business
                              challenges. The platform matches entrepreneurs
                              with experienced advisors to guide them through
                              crucial business decisions.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 ">
                        <div className="info-item">
                          <span className="info-number ">04.</span>
                          <div className="info-content">
                            <h5 className="info-title">
                              Investor Access and Funding Guidance
                            </h5>
                            <p className="info-text">
                              Startups in the UIM program are granted access to
                              a network of investors seeking high-potential
                              ventures. Through personalized pitch coaching and
                              business model optimization, UIM prepares startups
                              for successful funding rounds.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 ">
                        <div className="info-item">
                          <span className="info-number ">05.</span>
                          <div className="info-content">
                            <h5 className="info-title">
                              Real-Time Analytics and Metrics
                            </h5>
                            <p className="info-text">
                              UIM’s data-driven platform provides startups with
                              real-time analytics on key business metrics, from
                              market performance to financial health.
                              Entrepreneurs can make data-informed decisions
                              that drive growth and performance.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 ">
                        <div className="info-item">
                          <span className="info-number ">05.</span>
                          <div className="info-content">
                            <h5 className="info-title">
                              Quick Access to Vital Startup Resources
                            </h5>
                            <p className="info-text">
                              We provide startups with instant access to a wide
                              range of resources, including templates, legal
                              documents, financial tools, team of lawyers,
                              chartered accounts, human resources, compliance
                              managers, marketing strategies, and more.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="cta-area ">
                    <a className=" btn-solid " href="about-us.html">
                      get in toutch
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*End first about div*/}
        </div>
      </section>

      <section className="pricing mega-section  " id="pricing-1">
        <div className="container">
          <div className="sec-heading  ">
            <div className="content-area">
              <span
                className=" pre-title       wow fadeInUp "
                data-wow-delay=".2s">
                Subscription-Based Models
              </span>
              <h2 className=" title    wow fadeInUp" data-wow-delay=".4s">
                <span className="hollow-text">affordable</span> pricing plans
              </h2>
              <p className="subtitle   wow fadeInUp " data-wow-delay=".6s">
                UIM offers flexible and cost-effective pricing plans tailored to
                suit the needs of your startup.
              </p>
            </div>
            {/* <div className=" cta-area   wow fadeInUp" data-wow-delay=".8s">
                  <a className="cta-btn btn-solid    " href="pricing.html">
                    Subscribe Now
                    <i className="bi bi-arrow-right icon " />
                  </a>
                </div> */}
          </div>
          <div className="row">
            {/*First Plan*/}
            <div className="col-12  col-md-6 col-xl-3  mx-auto price-plan ">
              <div
                className="plan  text-center wow fadeInUp  "
                data-wow-delay=".1s ">
                <div className="plan-head">
                  <i className="flaticon-nft-1 plan-icon" />
                  <h4 className="plane-name">Alpha (Trial)</h4>
                  <div className="plan-price">
                    <h3 className="price">
                      00<sup className="currency-symbol">$</sup>
                    </h3>
                    <span className="per">Per Month</span>
                  </div>
                </div>
                <div className="plan-details">
                  <ul className="plan-list">
                    <li className="plan-feat ">
                      <span className="feat-text">o Duration: 4 Weeks</span>
                    </li>
                    <li className="plan-feat ">
                      <span className="feat-text">o Dedicated Mentors : 2</span>
                    </li>
                    <li className="plan-feat ">
                      <span className="feat-text">
                        o Who it’s For: Very early-stage startups.
                      </span>
                    </li>
                    <li className="plan-feat ">
                      <span className="feat-text">
                        o Services: Basic guidance, idea validation, draft
                        business model creation, access to startup resources,
                        and community support.
                      </span>
                    </li>
                    <li className="plan-feat ">
                      <span className="feat-text">
                        o Key Goal: Equip startups with foundational support to
                        bring their ideas to life.
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="plan-cta">
                  <a className="cta-btn btn-outline " href="#0">
                    select plan{" "}
                  </a>
                </div>
              </div>
            </div>
            {/*Second-plan*/}
            <div className="col-12  col-md-6 col-xl-3  mx-auto price-plan ">
              <div
                className="plan  text-center wow fadeInUp  "
                data-wow-delay=".3s ">
                <div className="plan-head">
                  <i className="flaticon-virtual-reality plan-icon" />
                  <h4 className="plane-name">Beta plan (90 Days)</h4>
                  <div className="plan-price">
                    <h3 className="price">
                      101<sup className="currency-symbol">$</sup>
                    </h3>
                    <span className="per">Per Month</span>
                  </div>
                </div>
                <div className="plan-details">
                  <ul className="plan-list">
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text"> o Duration : 3 Months</span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">o Dedicated Mentors : 3</span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        o Who it’s For: Startups ready to move beyond ideation.
                      </span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        o Services: Business model refinement, MVP development,
                        and legal compliance assistance.
                      </span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        o Key Goal: Guide startups in establishing MVP with a
                        structured approach to market entry.
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="plan-cta">
                  <a className="cta-btn btn-outline " href="#0">
                    select plan{" "}
                  </a>
                </div>
              </div>
            </div>
            {/*Third-plan*/}
            <div className="col-12  col-md-6 col-xl-3  mx-auto price-plan ">
              <div
                className="plan   featured  wow fadeInUp  "
                data-wow-delay=".5s ">
                <div className="plan-head">
                  <i className="flaticon-box plan-icon" />
                  <h4 className="plane-name">Gamma plan (90 Days)</h4>
                  <div className="plan-price">
                    <h3 className="price">
                      225<sup className="currency-symbol">$</sup>
                    </h3>
                    <span className="per">Per Month</span>
                  </div>
                </div>
                <div className="plan-details">
                  <ul className="plan-list">
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">o Duration : 3 Months</span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">o Dedicated Mentors : 4</span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        o Who it’s For: Startups seeking Product Market Fit
                      </span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        o Services: Expanded mentorship, funding guidance, and
                        well curated product development offerings.
                      </span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        o Key Goal: Product Market Fit with accelerated growth
                        through comprehensive support.
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="plan-cta">
                  <a className="cta-btn btn-outline " href="#0">
                    select plan{" "}
                  </a>
                </div>
              </div>
            </div>
            {/*fourth-plan*/}
            <div className="col-12  col-md-6 col-xl-3  mx-auto price-plan ">
              <div className="plan    wow fadeInUp  " data-wow-delay=".6s ">
                <div className="plan-head">
                  <i className="flaticon-basic-shapes plan-icon" />
                  <h4 className="plane-name">Sigma Plan (90 Days)</h4>
                  <div className="plan-price">
                    <h3 className="price">
                      454<sup className="currency-symbol">$</sup>
                    </h3>
                    <span className="per">per month</span>
                  </div>
                </div>
                <div className="plan-details">
                  <ul className="plan-list">
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text"> o Duration : 3 Months</span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        {" "}
                        o Dedicated Mentors : 4
                      </span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        o Who it’s For: Startups ready for expansion and scale
                      </span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        {" "}
                        o Services: Focus on fundraising, team expansion, and
                        strategic business planning.
                      </span>
                    </li>
                    <li className="plan-feat ">
                      {" "}
                      <span className="feat-text">
                        {" "}
                        o Key Goal: Board Formation, Empower startups to scale
                        effectively and access new growth opportunities.
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="plan-cta">
                  <a className="cta-btn btn-outline " href="#0">
                    select plan{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End  pricing Section*/}
      {/* Start  testimonials Section*/}
      <section
        className="testimonials testimonials-1-col   has-dark-bg  mega-section "
        id="testimonials-img-bg">
        <div
          className="overlay-photo-image-bg parallax "
          data-bg-img="./assets/assets/images/sections-bg-images/1.jpg"
          data-bg-opacity=".25">
          {" "}
        </div>
        <div className="container">
          <div className="sec-heading  centered ">
            <div className="content-area">
              <span
                className=" pre-title       wow fadeInUp "
                data-wow-delay=".2s">
                testimonials
              </span>
              <h2 className=" title    wow fadeInUp" data-wow-delay=".4s">
                Startup <span className="hollow-text">testmonials</span>
              </h2>
            </div>
          </div>
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-10  mx-auto">
              <div
                className="swiper-container  wow fadeInUp  "
                data-wow-delay="0.2s">
                <div className="swiper-wrapper">
                  {/*First Slide*/}
                  <div className="swiper-slide">
                    <div className="testmonial-card d-flex align-items-center justify-content-center">
                      <div className="testimonial-content">
                        <div className="customer-img ">
                          <img
                            className="img-fluid "
                            loading="lazy"
                            src="./assets/assets/images/testimonials/1.png"
                            alt="First Slide "
                          />
                        </div>
                        <div className="customer-testimonial">
                          <div className="content">
                            <p className="testimonial-text ">
                              We were guided us through the complex process of
                              scaling our business internationally. Their
                              strategic planning, team-building resources, and
                              funding preparation were top-notch. Today, we’re
                              operating in multiple markets and are ready for
                              our next stage of growth.
                            </p>
                          </div>
                        </div>
                        <div className="customer-info ">
                          <div className="customer-details">
                            <p className="customer-name">Taufiq Rachman</p>
                            <p className="customer-role">Bandung, Indonesia</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Second Slide*/}
                  <div className="swiper-slide">
                    <div className="testmonial-card d-flex align-items-center justify-content-center">
                      <div className="testimonial-content">
                        <div className="customer-img ">
                          <img
                            className="img-fluid "
                            loading="lazy"
                            src="./assets/assets/images/testimonials/2.png"
                            alt="First Slide "
                          />
                        </div>
                        <div className="customer-testimonial">
                          <div className="content">
                            <p className="testimonial-text ">
                              The 3D virtual environment at UIM is an amazing
                              platform for collaboration and growth. Being able
                              to connect with mentors and other startups in an
                              interactive and engaging space made a huge
                              difference. This program helped me turn my vision
                              into reality.ndis explicabo odio tenetur nulla
                              sint vel.
                            </p>
                          </div>
                        </div>
                        <div className="customer-info ">
                          <div className="customer-details">
                            <p className="customer-name">May Ling Tan</p>
                            <p className="customer-role">Malaysia</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*third Slide*/}
                  <div className="swiper-slide">
                    <div className="testmonial-card d-flex align-items-center justify-content-center">
                      <div className="testimonial-content">
                        <div className="customer-img ">
                          <img
                            className="img-fluid "
                            loading="lazy"
                            src="./assets/assets/images/testimonials/3.png"
                            alt="First Slide "
                          />
                        </div>
                        <div className="customer-testimonial">
                          <div className="content">
                            <p className="testimonial-text ">
                              The Gamma Phase of UIM was instrumental in helping
                              me secure funding and expand my startup. The
                              tailored mentorship and growth roadmaps gave me a
                              clear strategy for scaling, which led to a 300%
                              increase in revenue in just six months. Their
                              support was exceptional!"
                            </p>
                          </div>
                        </div>
                        <div className="customer-info ">
                          <div className="customer-details">
                            <p className="customer-name">Fadilah Hassan,</p>
                            <p className="customer-role">
                              Kuala Lumpur, Malaysia
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="testmonial-card d-flex align-items-center justify-content-center">
                      <div className="testimonial-content">
                        <div className="customer-img ">
                          <img
                            className="img-fluid "
                            loading="lazy"
                            src="./assets/assets/images/testimonials/3.png"
                            alt="First Slide "
                          />
                        </div>
                        <div className="customer-testimonial">
                          <div className="content">
                            <p className="testimonial-text ">
                              We were provided invaluable support during our MVP
                              development stage. Their AI-driven insights and
                              business model refinement tools made a huge
                              difference. Thanks to their help, I successfully
                              launched my product and started gaining traction
                              in the market.
                            </p>
                          </div>
                        </div>
                        <div className="customer-info ">
                          <div className="customer-details">
                            <p className="customer-name">Araya Nimit</p>
                            <p className="customer-role">Bangkok, Thailand</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="testmonial-card d-flex align-items-center justify-content-center">
                      <div className="testimonial-content">
                        <div className="customer-img ">
                          <img
                            className="img-fluid "
                            loading="lazy"
                            src="./assets/assets/images/testimonials/3.png"
                            alt="First Slide "
                          />
                        </div>
                        <div className="customer-testimonial">
                          <div className="content">
                            <p className="testimonial-text ">
                              "UIM’s Alpha Phase gave me the perfect starting
                              point for my business idea. The mentorship and
                              structured guidance helped me validate my concept
                              and create a business model tailored to my market.
                              I now feel confident in taking the next steps
                              toward launching my startup."
                            </p>
                          </div>
                        </div>
                        <div className="customer-info ">
                          <div className="customer-details">
                            <p className="customer-name">Rizky Pratama</p>
                            <p className="customer-role">Jakarta, Indonesia</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*navigation buttons*/}
                <div className="swiper-button-prev">
                  <div className="left-arrow">
                    <i className="bi bi-chevron-left icon " />
                  </div>
                </div>
                <div className="swiper-button-next">
                  <div className="right-arrow">
                    <i className="bi bi-chevron-right icon " />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
